import React from 'react';
import ConfirmEmailChangeScreen from '../../src/screens/auth/ConfirmEmailChangeScreen';

export default function ConfirmEmailChangeRoute() {
  return <ConfirmEmailChangeScreen />;
}
